exports.regularity_two = {
'门men2': [ '们', '闷', '焖' ],
'門men2': [ '們', '悶', '燜' ],
'刂dao1': [ '到', '倒' ],
'子zi5': [ '子', '字', '仔', '孜', '籽', '孳' ],
'子zi3': [ '子', '字', '仔', '孜', '孳' ],
'麻ma2': [ '麼', '嘛', '嬷', '嬤' ],
'十shi2': [ '事', '使', '士', '蝨', '弑' ],
'相xiang4': [ '想', '箱', '湘', '厢', '廂', '缃', '緗' ],
'羊yang2': [ '样', '樣', '养', '養', '痒', '癢', '氧', '漾', '恙' ],
'巴ba1': [ '把', '吧', '爸', '靶', '耙', '钯', '鈀' ],
'女ru3': [ '如', '茹', '洳' ],
'从cong1': [ '从', '從', '丛' ],
'从cong2': [ '从', '從', '枞', '樅', '苁', '蓯' ],
'青qing1': [ '情', '请', '請', '晴', '氰', '箐' ],
'行xing2': [ '行', '荇' ],
'中zhong1': [ '种', '仲', '肿' ],
'中zhong4': [ '种', '钟', '忠', '衷', '肿', '盅' ],
'重zhong4': [ '種', '腫', '踵' ],
'几ji3': [ '几', '机', '記', '玑', '饥', '肌', '讥', '叽', '矶' ],
'几ji1': [ '几', '記', '麂', '虮' ],
'丬qiang2': [ '将', '锵' ],
'爿qiang2': [ '將', '鏘', '戕' ],
'占zhan1': [ '战', '站' ],
'主zhu3': [ '住', '注', '註', '驻', '駐', '柱', '蛀', '炷' ],
'丶zhu3': [ '住', '注', '註', '术', '術', '筑', '築', '驻', '駐', '柱', '蛀', '炷' ],
'幾ji3': [ '機', '璣', '饑', '譏', '嘰', '磯' ],
'申shen1': [ '神', '审', '胂' ],
'王wang4': [ '王', '往', '汪', '枉' ],
'王wang2': [ '王', '望', '往', '汪', '旺', '枉' ],
'长zhang3': [ '张', '帐', '涨', '账', '胀' ],
'長zhang3': [ '張', '帳', '漲', '賬', '脹' ],
'尼ni2': [ '呢', '泥', '妮', '昵', '伲' ],
'丨shu4': [ '书', '疏', '倏', '梳', '蔬' ],
'马ma3': [ '吗', '妈', '骂', '蚂', '杩' ],
'馬ma3': [ '嗎', '媽', '罵', '螞', '榪' ],
'比bi4': [ '比', '吡', '妣', '秕' ],
'匕bi3': [ '比', '毙', '斃' ],
'比bi3': [ '比', '毕', '毙', '陛', '庇', '跸', '毖', '哔', '狴', '荜', '筚' ],
'方fang1': [ '放', '房', '防', '仿', '彷', '访', '訪', '妨', '坊', '纺', '紡', '舫', '肪', '鲂', '魴' ],
'化hua4': [ '花', '华' ],
'亻ren2': [ '任', '恁', '仞', '荏' ],
'壬ren2': [ '任', '饪', '飪', '妊', '衽' ],
'人ren2': [ '认', '飪', '稔' ],
'甬tong3': [ '通', '痛' ],
'己ji3': [ '记', '纪', '紀', '忌', '觊', '跽' ],
'艮gen3': [ '跟', '根', '艮', '哏', '茛' ],
'艮gen4': [ '跟', '根', '艮', '哏' ],
'亥hai4': [ '孩', '咳', '骸', '胲' ],
'彐ji4': [ '即', '急', '饑', '唧' ],
'专zhuan1': [ '转', '传' ],
'專zhuan1': [ '轉', '傳' ],
'斤jin1': [ '近', '靳' ],
'白bai2': [ '百', '伯', '柏', '佰' ],
'仑lun2': [ '论', '抡' ],
'侖lun2': [ '論', '掄' ],
'官guan1': [ '管', '馆', '館' ],
'敬jing4': [ '驚', '警', '儆' ],
'正zheng1': [ '政', '整', '证', '怔', '症' ],
'大da4': [ '达', '哒', '耷', '鞑', '跶' ],
'令ling2': [ '领', '領', '岭' ],
'令ling4': [ '领',
'領',
'零',
'玲',
'铃',
'鈴',
'龄',
'齡',
'岭',
'伶',
'翎',
'聆',
'羚',
'苓',
'蛉',
'呤',
'泠',
'囹',
'瓴',
'鸰',
'鴒',
'舲' ],
'那na3': [ '哪', '娜' ],
'各ge4': [ '格', '阁', '閣', '胳', '咯', '骼', '袼' ],
'衣yi4': [ '衣', '依', '铱', '銥' ],
'衣yi1': [ '衣', '裔' ],
'古gu3': [ '故', '姑', '固', '估', '咕', '辜', '沽', '轱', '軲', '鸪', '鴣', '蛄', '酤' ],
'氐di1': [ '底', '抵', '邸', '砥', '诋', '詆', '柢', '骶', '坻' ],
'只zhi1': [ '识', '职', '帜', '咫', '枳', '轵', '軹' ],
'其qi2': [ '期', '欺' ],
'正zheng4': [ '整', '征', '怔', '症', '钲', '鉦' ],
'原yuan2': [ '愿', '願' ],
'壯zhuang4': [ '裝', '莊', '奘' ],
'肖xiao4': [ '消', '销', '銷', '削', '宵', '霄', '逍', '硝', '魈', '绡', '綃', '蛸' ],
'向xiang4': [ '响', '饷', '餉' ],
'鄉xiang1': [ '響', '饗' ],
'牙ya2': [ '呀', '雅', '讶', '訝', '鸦', '鴉', '迓', '砑' ],
'丽li4': [ '麗', '骊', '鹂', '逦' ],
'丽li2': [ '麗', '俪', '郦', '逦' ],
'云yun2': [ '运', '酝' ],
'耶ye1': [ '爺', '揶' ],
'耶ye5': [ '爺', '椰', '揶' ],
'交jiao1': [ '校', '较', '較', '狡', '绞', '絞', '饺', '餃', '皎', '佼', '铰', '鉸' ],
'干gan4': [ '赶', '趕', '杆', '桿', '肝', '竿', '秆', '稈', '擀', '矸', '筸' ],
'北bei3': [ '背', '褙', '邶' ],
'曷he2': [ '喝', '褐' ],
'反fan3': [ '饭', '飯', '贩', '販', '畈' ],
'句gou1': [ '够', '夠', '狗', '苟', '笱', '枸', '岣' ],
'居ju1': [ '据', '剧', '锯', '鋸', '踞', '倨' ],
'氐di3': [ '低', '羝' ],
'寸cun4': [ '村', '忖' ],
'安an1': [ '案', '按', '胺', '铵', '銨' ],
'叚jia3': [ '假', '葭' ],
'九jiu3': [ '究', '鸠', '鳩' ],
'艹cao3': [ '草', '曹', '槽', '嘈', '漕', '艚', '螬' ],
'生sheng1': [ '胜', '眚' ],
'单dan1': [ '弹', '惮', '掸', '瘅' ],
'單dan1': [ '彈', '憚', '撣', '癉' ],
'召zhao4': [ '招', '昭', '沼' ],
'付fu4': [ '府', '符', '苻', '拊', '跗' ],
'雨yu4': [ '雨', '雩' ],
'雨yu3': [ '雨', '雩' ],
'间jian1': [ '简', '涧', '锏', '裥' ],
'间jian4': [ '简', '锏', '裥' ],
'間jian1': [ '簡', '澗', '鐧', '襇' ],
'間jian4': [ '簡', '鐧', '襇' ],
'虍hu1': [ '虎', '唬', '琥' ],
'拉la1': [ '啦', '鞡' ],
'丁ding1': [ '顶', '頂', '订', '訂', '酊' ],
'韋wei2': [ '衛', '偉', '葦', '緯', '煒', '韙', '瑋' ],
'畐fu2': [ '副', '富' ],
'氏zhi1': [ '纸', '紙', '衹', '祇' ],
'旦dan4': [ '担', '胆', '疸' ],
'禺yu2': [ '遇', '寓' ],
'亡wang2': [ '忘', '妄' ],
'包bao1': [ '抱', '饱', '飽', '鲍', '鮑', '刨', '雹' ],
'勹bao1': [ '抱', '饱', '飽', '鲍', '鮑', '豹', '刨', '雹', '趵' ],
'奴nu2': [ '怒', '努', '弩', '呶' ],
'孟meng4': [ '猛', '蜢', '锰', '錳', '艋', '勐' ],
'加jia1': [ '架', '驾', '駕' ],
'某mou3': [ '谋', '謀' ],
'莫mo4': [ '模', '摸', '摹', '膜', '馍', '饃', '谟', '謨', '嫫' ],
'將jiang1': [ '蔣', '獎', '漿', '醬', '槳' ],
'將jiang4': [ '蔣', '獎', '漿', '槳' ],
'每mei3': [ '梅', '霉', '莓', '酶' ],
'介jie4': [ '价', '阶' ],
'昌chang1': [ '唱', '倡' ],
'米mi3': [ '迷', '谜', '謎', '眯', '瞇', '咪', '麋', '醚' ],
'真zhen1': [ '镇', '鎮', '缜', '縝', '稹' ],
'予yu2': [ '预', '預', '豫' ],
'予yu3': [ '预', '預', '豫', '妤' ],
'巠jing1': [ '勁', '徑', '頸', '痙', '逕', '脛', '剄' ],
'吴wu2': [ '误', '誤' ],
'阝fu3': [ '附', '郛' ],
'乍zha4': [ '炸', '砟' ],
'采cai4': [ '彩', '踩', '睬' ],
'㐱zhen3': [ '珍', '胗' ],
'分fen4': [ '纷', '紛', '粉', '芬', '吩', '氛', '汾', '酚', '玢', '棼' ],
'廷ting2': [ '挺', '艇', '铤', '鋌', '梃', '綎' ],
'菐pu2': [ '撲', '噗', '蹼' ],
'共gong4': [ '供', '恭', '拱', '龚', '龔' ],
'于yu2': [ '宇', '吁', '迂', '芋', '纡', '紆' ],
'票piao4': [ '飘', '飄', '漂', '瞟', '嫖', '瓢', '缥', '縹', '剽', '嘌' ],
'尤you2': [ '优', '忧' ],
'奇ji1': [ '骑', '騎', '寄' ],
'酉you3': [ '猶', '猷', '蕕', '輶' ],
'高gao1': [ '搞', '稿', '镐', '鎬', '槁', '缟', '縞', '藁' ],
'卷juan3': [ '圈', '倦', '锩', '錈' ],
'用yong4': [ '拥',
'涌',
'湧',
'庸',
'佣',
'傭',
'恿',
'慂',
'甬',
'踊',
'慵',
'蛹',
'俑',
'痈',
'镛',
'鏞',
'墉' ],
'韦wei2': [ '伟', '苇', '纬', '炜', '韪', '玮' ],
'監jian1': [ '艦', '檻' ],
'參can1': [ '慘', '黲' ],
'奄yan1': [ '掩', '罨' ],
'空kong1': [ '控', '倥' ],
'斗dou4': [ '抖', '蚪' ],
'夆feng2': [ '峰', '锋', '鋒', '蜂', '烽' ],
'俞yu2': [ '愈', '谕', '諭', '喻' ],
'土tu3': [ '吐', '堍' ],
'义yi4': [ '仪', '蚁' ],
'乂yi4': [ '仪', '蚁' ],
'義yi4': [ '儀', '蟻' ],
'勾gou1': [ '构', '购' ],
'扁pian1': [ '骗', '騙', '匾', '楄', '谝', '諞', '蹁' ],
'分fen1': [ '粉', '忿', '汾', '棼' ],
'彦yan4': [ '颜', '顔' ],
'弟ti4': [ '梯', '鹈', '鵜', '绨', '綈', '锑', '銻' ],
'委wei3': [ '魏', '萎', '逶' ],
'委wei1': [ '魏', '萎', '诿', '諉', '痿' ],
'令ling3': [ '零',
'玲',
'铃',
'鈴',
'龄',
'齡',
'伶',
'翎',
'聆',
'羚',
'苓',
'蛉',
'呤',
'泠',
'囹',
'瓴',
'鸰',
'鴒',
'舲' ],
'留liu2': [ '溜', '遛', '熘', '馏', '餾', '蹓', '罶' ],
'恩en1': [ '嗯', '摁' ],
'争zheng1': [ '挣', '诤', '諍' ],
'叟sou3': [ '搜', '艘', '嗖', '飕', '颼', '馊', '餿', '锼', '鎪', '溲', '螋' ],
'夫fu1': [ '扶', '芙', '蚨' ],
'里li3': [ '哩', '狸', '貍', '厘', '釐', '喱' ],
'登deng1': [ '瞪', '鄧', '澄', '嶝', '镫', '鐙', '磴' ],
'旋xuan4': [ '璇', '漩' ],
'勾gou4': [ '沟', '钩' ],
'冓gou4': [ '溝', '篝' ],
'逢feng2': [ '缝', '縫' ],
'小xiao3': [ '萧', '啸', '潇', '箫' ],
'荅da2': [ '搭', '褡' ],
'非fei1': [ '菲', '匪', '斐', '翡', '诽', '誹', '腓', '蜚', '榧', '悱', '痱' ],
'旁pang2': [ '膀', '滂', '耪' ],
'尃fu1': [ '傅', '缚', '縛', '赙', '賻' ],
'吾wu2': [ '悟', '捂', '晤', '焐', '牾', '痦' ],
'龙long2': [ '笼', '拢', '陇', '垄', '垅' ],
'龍long2': [ '籠', '攏', '隴', '壟', '壠' ],
'当dang1': [ '挡', '档' ],
'当dang4': [ '挡', '裆', '铛' ],
'當dang1': [ '擋', '檔' ],
'當dang4': [ '擋', '襠', '鐺' ],
'同tong4': [ '铜', '銅', '筒', '桐', '峒', '侗', '酮' ],
'家jia1': [ '嫁', '稼' ],
'啇di2': [ '滴', '镝', '鏑' ],
'口kou3': [ '扣', '叩', '佝', '筘' ],
'敖ao2': [ '傲', '熬', '鏊', '骜', '驁' ],
'可ke3': [ '柯', '苛', '珂', '轲', '軻', '疴' ],
'可ke4': [ '柯', '苛', '珂', '轲', '軻', '坷', '岢', '疴' ],
'并bing4': [ '屏', '饼', '餅' ],
'妻qi4': [ '凄', '淒', '棲', '萋' ],
'禺yu4': [ '愚', '隅' ],
'喜xi3': [ '嘻', '嬉', '熹', '僖' ],
'巾jin1': [ '锦', '錦' ],
'章zhang1': [ '障', '瘴', '嶂', '幛' ],
'與yu2': [ '譽', '嶼' ],
'與yu3': [ '譽', '歟' ],
'荒huang1': [ '谎', '謊' ],
'夫fu2': [ '肤', '趺', '呋', '麸', '麩' ],
'亚ya4': [ '哑', '桠' ],
'亞ya4': [ '啞', '椏' ],
'夸kua1': [ '跨', '垮', '挎', '胯', '侉' ],
'桑sang1': [ '嗓', '搡', '颡', '顙' ],
'工gong1': [ '贡', '貢', '巩', '鞏', '汞', '銾' ],
'辟pi4': [ '劈', '霹', '癖', '噼' ],
'华hua2': [ '哗', '桦' ],
'华hua4': [ '哗', '骅', '铧' ],
'華hua2': [ '嘩', '樺' ],
'華hua4': [ '嘩', '驊', '鏵' ],
'占zhan4': [ '沾', '粘', '毡' ],
'宜yi2': [ '谊', '誼' ],
'先xian1': [ '宪', '铣', '銑', '跣', '冼', '筅' ],
'东dong1': [ '冻', '栋' ],
'東dong1': [ '凍', '棟' ],
'鬼gui3': [ '瑰', '傀' ],
'出chu1': [ '础', '黜', '绌', '絀' ],
'了liao3': [ '疗', '辽' ],
'了liao4': [ '疗', '辽', '钌', '釕' ],
'夹jia1': [ '颊', '郏', '荚', '蛱', '铗' ],
'夾jia1': [ '頰', '郟', '莢', '蛺', '鋏' ],
'邦bang1': [ '绑', '綁' ],
'凡fan2': [ '帆', '梵' ],
'賏ying4': [ '嬰', '櫻', '鸚', '嚶', '纓', '罌', '癭', '攖', '瓔' ],
'句ju4': [ '拘', '驹', '駒', '枸' ],
'折zhe2': [ '浙', '蜇' ],
'宛wan3': [ '腕', '蜿', '剜', '豌' ],
'君jun1': [ '郡', '捃' ],
'至zhi4': [ '侄', '姪' ],
'次ci4': [ '茨', '瓷' ],
'娄lou2': [ '搂', '喽', '篓', '镂', '嵝', '瘘' ],
'婁lou2': [ '摟', '嘍', '簍', '鏤', '嶁', '瘻' ],
'戋jian1': [ '践', '贱', '溅', '饯' ],
'戔jian1': [ '踐', '賤', '濺', '餞' ],
'连lian2': [ '链', '琏' ],
'連lian2': [ '鏈', '璉' ],
'奄yan3': [ '淹', '阉', '閹', '腌', '醃', '崦' ],
'司si1': [ '嗣', '伺', '饲', '飼', '笥' ],
'台tai2': [ '胎', '苔' ],
'崩beng1': [ '蹦', '繃', '鏰', '镚' ],
'困kun4': [ '捆', '綑', '阃', '閫', '悃' ],
'畾lei2': [ '壘', '儡' ],
'蒙meng3': [ '朦', '檬', '矇', '艨', '礞' ],
'蒙meng1': [ '朦', '檬', '蠓', '矇', '艨', '礞' ],
'曾zeng1': [ '赠', '贈', '甑', '缯', '繒' ],
'夹jia2': [ '挟', '浃' ],
'夾jia2': [ '挾', '浹' ],
'剌la2': [ '喇', '瘌' ],
'合ge2': [ '鸽', '鴿' ],
'劳lao2': [ '捞', '唠', '涝' ],
'劳lao4': [ '捞', '唠', '崂', '痨' ],
'勞lao2': [ '撈', '嘮', '澇' ],
'勞lao4': [ '撈', '嘮', '嶗', '癆' ],
'卯mao3': [ '贸', '貿', '茆' ],
'丶dian3': [ '垫', '墊' ],
'壹yi1': [ '懿', '殪' ],
'冋jiong1': [ '炯', '迥', '絅' ],
'冂jiong1': [ '炯', '迥', '絅' ],
'父fu4': [ '斧', '釜', '滏' ],
'匊ju2': [ '鞠', '掬' ],
'咅pou3': [ '剖', '掊' ],
'柬jian3': [ '谏', '諫' ],
'匡kuang1': [ '框', '眶' ],
'玄xuan2': [ '眩', '炫', '铉', '鉉', '泫' ],
'鲁lu3': [ '噜', '撸' ],
'魯lu3': [ '嚕', '擼' ],
'胥xu1': [ '婿', '糈' ],
'利li4': [ '梨', '犁', '蜊' ],
'宁ning2': [ '拧', '泞' ],
'寧ning4': [ '擰', '獰', '嚀', '檸' ],
'寧ning2': [ '擰', '濘' ],
'区ou1': [ '呕', '沤', '怄' ],
'區ou1': [ '嘔', '漚', '慪' ],
'与yu4': [ '屿', '欤' ],
'與yu4': [ '嶼', '歟' ],
'此ci3': [ '雌', '疵' ],
'执zhi2': [ '挚', '鸷', '贽' ],
'執zhi2': [ '摯', '鷙', '贄' ],
'面mian4': [ '缅', '緬', '腼', '靦', '湎' ],
'曼man4': [ '蔓', '馒', '饅', '谩', '謾', '鳗', '鰻' ],
'长chang2': [ '怅', '伥' ],
'長chang2': [ '悵', '倀', '鋹' ],
'更geng1': [ '梗', '哽', '埂', '鲠', '鯁', '绠', '綆' ],
'更geng4': [ '梗', '哽', '埂', '鲠', '鯁', '绠', '綆' ],
'呈cheng2': [ '逞', '裎' ],
'完wan2': [ '皖', '莞' ],
'幼you4': [ '黝', '呦' ],
'咠qi4': [ '缉', '緝' ],
'念nian4': [ '捻', '鲶', '鯰' ],
'旬xun2': [ '殉', '徇' ],
'赞zan4': [ '攒', '趱' ],
'贊zan4': [ '攢', '趲' ],
'山shan1': [ '讪', '訕', '汕', '疝' ],
'雷lei2': [ '蕾', '擂' ],
'畏wei4': [ '偎', '猥', '煨', '隈' ],
'乞qi3': [ '迄', '讫', '訖', '汔' ],
'严yan2': [ '俨', '酽' ],
'嚴yan2': [ '儼', '釅' ],
'民min2': [ '抿', '泯' ],
'曾ceng2': [ '蹭', '噌' ],
'辱ru3': [ '褥', '缛', '縟', '溽', '蓐' ],
'朵duo3': [ '跺', '垛', '剁' ],
'即ji2': [ '唧', '鲫', '鯽' ],
'宾bin1': [ '鬓', '殡', '膑', '摈', '髌' ],
'賓bin1': [ '鬢', '殯', '臏', '擯', '髕' ],
'奇qi2': [ '绮', '綺' ],
'窜cuan4': [ '蹿', '撺' ],
'竄cuan4': [ '躥', '攛' ],
'文wen2': [ '紊', '汶' ],
'危wei1': [ '桅', '頠' ],
'达da2': [ '哒', '跶' ],
'達da2': [ '噠', '躂' ],
'彡shan1': [ '掺', '摻' ],
'保bao3': [ '褒', '煲' ],
'考kao3': [ '铐', '銬' ],
'夗yuan4': [ '鸳', '鴛' ],
'冉ran3': [ '髯', '蚺' ],
'囊nang2': [ '囔', '馕', '饢', '攮' ],
'无wu2': [ '妩', '庑', '怃' ],
'無wu2': [ '嫵', '廡', '憮' ],
'店dian4': [ '掂', '踮' ],
'番fan1': [ '蕃', '燔', '蹯' ],
'爰yuan2': [ '媛', '瑗' ],
'厥jue2': [ '撅', '噘', '蹶' ],
'含han2': [ '颔', '頷' ],
'宣xuan1': [ '渲', '楦' ],
'吉ji2': [ '髻', '咭' ],
'吕lu:3': [ '榈', '櫚', '闾', '閭' ],
'言yan2': [ '諺', '唁', '讞' ],
'於yu2': [ '淤', '菸', '瘀' ],
'厌yan4': [ '魇', '恹', '厣' ],
'毛mao2': [ '耄', '旄', '眊' ],
'從cong2': [ '樅', '蓯' ],
'脊ji3': [ '瘠', '嵴', '蹐', '鹡', '鶺' ],
'堇jin3': [ '觐', '覲' ],
'矛mao2': [ '懋', '袤', '瞀' ],
'叉cha2': [ '杈', '衩', '汊' ],
'叉cha3': [ '杈', '衩', '汊' ],
'叉cha1': [ '杈', '衩', '汊' ],
'麗li2': [ '儷', '酈', '邐' ],
'由you2': [ '柚', '釉', '鼬' ],
'来lai2': [ '睐', '赉' ],
'來lai2': [ '睞', '賚' ],
'亢kang4': [ '闶', '閌' ],
'空kong4': [ '崆', '倥', '箜' ],
'见jian4': [ '笕', '枧' ],
'見jian4': [ '筧', '梘' ],
'佘she2': [ '赊', '賒', '畲' ],
'川chuan1': [ '钏', '釧' ],
'臾yu2': [ '庾', '瘐' ],
'麗li4': [ '驪', '鸝', '邐' ],
'差cha4': [ '槎', '艖' ],
'有you3': [ '宥', '囿', '侑' ],
'焦jiao1': [ '醮', '噍' ],
'蒙meng2': [ '蠓', '矇' ],
'强qiang2': [ '襁', '镪', '鏹' ],
'堂tang2': [ '蹚', '镗', '鏜' ],
'炎yan2': [ '琰', '剡' ],
'去qu4': [ '祛', '胠' ],
'奔ben4': [ '锛', '錛' ],
'追zhui1': [ '缒', '縋' ],
'充chong1': [ '铳', '銃' ],
'止zhi3': [ '陟', '骘', '騭' ],
'局ju2': [ '锔', '鋦' ],
'强qiang3': [ '镪', '鏹' ],
'建jian4': [ '鞬', '犍' ],
'甚shen2': [ '葚', '椹' ],
'甘gan1': [ '绀', '紺' ],
'翏liu4': [ '镠', '鏐' ],
'布bu4': [ '钸', '鈽' ],
'扇shan1': [ '骟', '騸' ],
'旋xuan2': [ '镟', '鏇' ]};